/* External */
import { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import platform from '../../utils/platform';
import { useOnKeyDown } from '../../utils/keyDownEvents';
import { SCROLL_TO_MOVE } from '../TermsOfService/constants';

/* Style */
import './ScrollBarContent.scss';

const NAVIGATION_KEY_CODES = [platform.keyCodes.navigation.up, platform.keyCodes.navigation.down];

function ScrollBarContent({ children }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const scrollTopContent = useRef(0);
  const refScrollElement = useRef();

  const handleManuallyScroll = useCallback(
    ({ keyCode }) => {
      refScrollElement.current.scrollTop = keyCode === platform.keyCodes.navigation.down
        ? scrollTopContent.current + SCROLL_TO_MOVE
        : scrollTopContent.current - SCROLL_TO_MOVE;
    },
    [],
  );

  useOnKeyDown({ listener: handleManuallyScroll, forKeyCodes: NAVIGATION_KEY_CODES });

  const handleOnScroll = useCallback(
    (event) => {
      scrollTopContent.current = event.target.scrollTop;
      setIsScrolled(event.target.scrollTop > 5);
    },
    [],
  );

  return (
    <div
      className={`dtv-html5-c-scrollbar-content
      ${isScrolled ? 'dtv-html5-c-scrollbar-content--scrolled' : ''}`}
    >
      <div
        className="dtv-html5-c-scrollbar-content__inner"
        onScroll={handleOnScroll}
        ref={refScrollElement}
      >
        {children}
      </div>
    </div>
  );
}

ScrollBarContent.propTypes = {
  children: PropTypes.node.isRequired,
};

ScrollBarContent.defaultProps = {};

export default ScrollBarContent;
